import { render, staticRenderFns } from "./AddCorContract.vue?vue&type=template&id=25e15d72&scoped=true&"
import script from "./AddCorContract.vue?vue&type=script&lang=js&"
export * from "./AddCorContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e15d72",
  null
  
)

export default component.exports